<template>
  <section class="work-selector">
    <section class="work">
      <div class="bd">
        <!-- <a href="changba://?ac=musicboard" class="record" @click="stopAudio">
          <img src="~@cdn_img/icon-1.svg">
          录制新的
        </a> -->

        <div class="tips">
          <p>选择要修音的作品</p>
          <p>将对方作品保存至收藏夹即可出现</p>
        </div>

        <audio :src="playerSrc | replaceUrlProtocol" ref="player" @play="play" @pause="stop" @ended="stop" @error="stop"></audio>

        <van-list v-model="loading" :finished="finished" @load="refresh" v-if="listing.length">
          <ul>
            <li v-for="(item, index) in listing" :key="item.work.workid">
              <div class="media">
                <div class="media-left">
                  <button type="button" class="player-button" :class="{ active: item.__playing }" @click="handlePlay(index, item.work.workpath)">
                    <cover :data-src="item.work.cover.path | avatar(100)" class="lazyload" :alt="item.work.song.name" />
                  </button>
                </div>
                <div class="media-body">
                  <h3 :class="{ video: !!item.work.video }"><span>{{ item.work.song.name }}</span></h3>
                  <p><span class="time">{{ item.secondText }}</span></p>
                </div>
                <div class="media-right">
                  <button type="button" class="btn disabled" @click="$toast.fail(item.msg)" v-if="item.msg">无法制作</button>
                  <button type="button" class="btn" @click="make(item.work.workid)" v-else>去制作</button>
                </div>
              </div>
            </li>
          </ul>
        </van-list>
        <div class="empty" v-else>
          <div class="pic"></div>
          <p>暂无内容</p>
        </div>
      </div>
    </section>

    <section class="footer">
      <p>我是有底线的</p>
    </section>
  </section>
</template>

<script>
import Cover from '../components/Cover';
import qs from 'qs';

export default {
  name: 'WorkSelector',

  components: {
    Cover
  },

  props: {
    id: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      listing: [],
      page: 1,
      playerSrc: '',
      playingIndex: -1,
      loading: false,
      finished: false
    };
  },

  created() {
    this.refresh();
  },

  methods: {
    async refresh() {
      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicService/musicmall/getWorkListByUserNew', {
        data: {
          orderid: this.id,
          type: 2,
          page: 1,
          num: 30
        }
      });

      this.$toast.clear();

      this.loading = false;

      if (code === 1) {
        if (data.list?.length > 0) {
          const result = data.list.map(item => {
            // 手动增加一个播放状态
            item.__playing = false;
            return item;
          });

          this.listing = result;
        }
      }

      this.finished = true;
    },

    stopAudio() {
      const elements = document.querySelectorAll('audio');

      for (let i = 0; i < elements.length; i++) {
        elements[i].pause();
      }
    },

    handlePlay(index, src) {
      this.stopAudio();
      this.stop(index);

      this.playingIndex = index;
      this.playerSrc = src;

      this.$nextTick(() => {
        if (this.listing[this.playingIndex].__playing) {
          this.$refs.player.pause();
        }
        else {
          this.$refs.player.play();
        }
      });
    },

    play() {
      this.listing[this.playingIndex].__playing = true;
    },

    stop(ignore) {
      this.listing.forEach((item, index) => {
        if (ignore === index) {
          return;
        }
        item.__playing = false;
      });
    },

    async make(workId) {
      if (this.$route.query.back_type === 'buy') {
        const query = qs.parse(this.$route.query.back_query);
        query.id = workId;
        this.$router.push({
          path: `/buy`,
          query
        });
      }
      else {
        this.$toast.loading();

        const { code, msg } = await this.$fetch('/api/musicService/musicmall/createOrderMaterial', {
          method: 'post',
          data: {
            orderid: this.id,
            dataType: 0,
            dataid: workId
          }
        });

        this.$toast.clear();

        if (code === 1) {
          this.$toast.success('上传成功');
          setTimeout(() => {
            this.$router.push(`/order/${this.id}`);
          }, 1500);
        }
        else {
          this.$toast.fail(msg);
        }

      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@cdn_js/styles/work-selector.scss";
</style>
